import { InjectionToken } from '@angular/core';
import { ApplicationVersion } from '@core/interfaces/application-version.interface';
import { currentApplicationVersion } from 'src/generated/application-version';

export interface ApplicationVersionBrowser {
  fetch: Window['fetch'];
  setInterval: Window['setInterval'];
  clearInterval: Window['clearInterval'];
  addEventListener: Window['addEventListener'];
  removeEventListener: Window['removeEventListener'];
  document: Pick<Document, 'baseURI' | 'visibilityState' | 'addEventListener' | 'removeEventListener'>;
}

export interface ApplicationVersionConfig {
  pollInterval: number;
  versionUrl: string;
}

export const APPLICATION_VERSION_BROWSER = new InjectionToken<ApplicationVersionBrowser>(
  'Application version browser APIs',
  {
    providedIn: 'root',
    factory: () => window,
  },
);

export const APPLICATION_VERSION_CONFIG = new InjectionToken<ApplicationVersionConfig>('Application version config', {
  providedIn: 'root',
  factory: () => ({
    pollInterval: 5 * 60 * 1000,
    versionUrl: 'version.json',
  }),
});

export const APPLICATION_CURRENT_VERSION = new InjectionToken<ApplicationVersion>('Current application version', {
  providedIn: 'root',
  factory: () => currentApplicationVersion,
});
